<template>
<div>
  <div
    id="g_id_onload"
    :data-client_id="googleClientID"
    data-callback="handleCredentialResponse"></div>
  <div
    id="g_id_signin"
    data-type="standard"
    :data-width="width"
    :data-height="height"></div>
</div>
</template>

<script>
export default {
  props: {
    scope: {
      type: String,
      default: 'profile email',
    },
    width: {
      type: Number,
      default: 240,
    },
    height: {
      type: Number,
      default: 50,
    },
  },

  data: () => ({
    googleClientID: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  }),

  mounted() {
    window.handleCredentialResponse = this.handleCredentialResponse;
    this.initializeGoogleButton();
  },

  methods: {
    handleCredentialResponse(response) {
      const responsePayload = response.credential;
      this.$emit('success', responsePayload);
    },
    initializeGoogleButton() {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: this.googleClientID,
          callback: this.handleCredentialResponse,
        });
        window.google.accounts.id.renderButton(
          document.getElementById('g_id_onload'),
          { theme: 'outline', size: 'large' },
        );
      }
    },
  },
};
</script>
